// extracted by mini-css-extract-plugin
export default {"inputGroup":"input-group_inputGroup__37Z9p","disabled":"input-group_disabled__D4MsN"};